<script setup>
/**
 * Column rule shared by every member-card grid (GH-1441). Columns follow
 * the width actually available, auto-filling against the card's minimum
 * width, instead of the viewport: the friends pages sit beside a 352px
 * sidebar from `md` up while a visitor's Followers tab has the full
 * profile width, so viewport breakpoints put three 140px cards in one and
 * two 210px cards in the other.
 */
</script>

<template>
    <div
        class="grid grid-cols-[repeat(auto-fill,minmax(min(100%,300px),1fr))] gap-6"
    >
        <slot />
    </div>
</template>
